import React from 'react';

type ArrowAltitudeProps = {
  metersAbove: number | null;
  metersBelow: number | null;
};

const ArrowAltitude = ({
  metersAbove,
  metersBelow
}: ArrowAltitudeProps): JSX.Element | null => {
  const isAbove = metersAbove != null;
  const isBelow = metersBelow != null;

  if (!isAbove && !isBelow) {
    return null;
  }

  const value = isAbove ? metersAbove : metersBelow;
  const label = 'möh'
  const rotation = isBelow ? 'rotate(180deg)' : 'none';

  if (!isAbove && !isBelow) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center mr-4 md:mr-6">
      <figure>
        <svg
          width="23"
          height="28"
          viewBox="0 0 23 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: rotation }}
        >
          <path
            d="M0.850773 11.7575L10.6239 0.762711C11.0217 0.315196 11.721 0.315196 12.1187 0.762711L21.8919 11.7575C22.4651 12.4024 22.0073 13.4219 21.1445 13.4219H16.3713V26.9219C16.3713 27.4742 15.9236 27.9219 15.3713 27.9219H7.37134C6.81905 27.9219 6.37134 27.4742 6.37134 26.9219V13.4219H1.59818C0.735333 13.4219 0.277527 12.4024 0.850773 11.7575Z"
            fill="#FF3D00"
          />
        </svg>
      </figure>
      <span className="text-xs"><span>{value}</span><span className="sm:pl-0 pl-1">{label}</span></span>
    </div>
  )

};

export default ArrowAltitude;
